<app-logo-area [breadcrumbs]="breadCrumbs()"></app-logo-area>
<main>
  <app-headline-section
    [title]="airline()?airline().airline_possessive + ' Previews':''">
  </app-headline-section>


  <app-filter-section [all]="poItems$()" [filtered]="poItemsSortedFiltered$()" [formGroup]="filters">
    <form [formGroup]="filters" class="cl-form">
      <input type="text" style="width: 100%" formControlName="t"
             placeholder="Filter by ID and name" autofocus>
      <p class="valid-feedback">Filter terms are case-insensitive.</p>
    </form>
  </app-filter-section>
  <section class="cl-section cl-section-regular">

    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="cl-table-scroll">
            <table class="cl-table-data">
              <thead>
              <tr>
                <th class="cl-table-head">Project Name</th>
                <th class="cl-table-head">Title</th>
                <th class="cl-table-head">Date</th>
                <th class="cl-table-head cl-th-links"></th>
              </tr>
              </thead>
              <tbody>
              @if (loading) {
                <tr class="cl-tr-no-data">
                  <td colspan="100"><div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div></td>
                </tr>
              } @else if (loadError) {
                <tr class="cl-tr-no-data">
                  <td colspan="100" role="alert">Could not load the previews: {{ loadError }}</td>
                </tr>
              } @else {
                @if (poItemsSortedFiltered$(); as poItemsFiltered) {
                  <tr>
                    <td colspan="4">
                      <a [routerLink]="['/o', organization()?.id, 'previews']">.. (up)</a>
                    </td>
                  </tr>
                  @for (poitem of poItemsFiltered; track poitem) {
                    <tr>
                      <td>{{ poitem.po.po_name }}</td>
                      <td>
                        {{ poitem.po_item_id }}
                      </td>
                      <td class="cl-td-time"><app-date [value]="poitem.preview.dash_manifest_last_modified" /></td>
                      <td class="cl-td-links" width="1%"><a class="cl-a-btn cl-a-primary"
                             [routerLink]="['/o',this.organization()?.id , 'previews', poitem.po.airline, poitem.po.po_name, poitem.po_item_id, 'preview']">Preview</a>
                      </td>
                    </tr>
                  } @empty {
                    <tr class="cl-tr-no-data">
                      <td colspan="100">No data available.</td>
                    </tr>
                  }
                }
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
